'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cwUi = require('cw-ui');

var _AutomationName = require('../../../services/AutomationName');

var _AutomationName2 = _interopRequireDefault(_AutomationName);

var _Locale = require('../../../Locale');

var _Locale2 = _interopRequireDefault(_Locale);

var _reactIntl = require('react-intl');

var _ClickTracker = require('../../../services/ClickTracker');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @type {React.StatelessComponent} */
var ColorField = function ColorField(props) {
  var getColors = function getColors() {
    var formatMessage = props.intl.formatMessage;


    return [{ id: "#E50000", name: formatMessage(_Locale2.default.red) }, { id: "#FA9B02", name: formatMessage(_Locale2.default.orange) }, { id: "#F7E03E", name: formatMessage(_Locale2.default.yellow) }, { id: "#F10065", name: formatMessage(_Locale2.default.pink) }, { id: "#583FD6", name: formatMessage(_Locale2.default.purple) }, { id: "#9A8BE6", name: formatMessage(_Locale2.default.lightPurple) }, { id: "#3474FB", name: formatMessage(_Locale2.default.blue) }, { id: "#4BAEFA", name: formatMessage(_Locale2.default.lightBlue) }, { id: "#2FC201", name: formatMessage(_Locale2.default.green) }, { id: "#88D621", name: formatMessage(_Locale2.default.lightGreen) }, { id: "#CCCCCC", name: formatMessage(_Locale2.default.lightGray) }, { id: "#5E5E5E", name: formatMessage(_Locale2.default.darkGray) }];
  };

  var getAutomationName = function getAutomationName() {
    return _AutomationName2.default.get('clr', props.automationName);
  };

  var handleChange = function handleChange(value) {
    (0, _ClickTracker.addEditTrack)(getAutomationName());
    props.onChange(value);
  };

  return _react2.default.createElement(_cwUi.CwColorField, (0, _assign2.default)({}, props, {
    cwId: getAutomationName(),
    onChange: props.onChange ? handleChange : undefined,
    colors: getColors()
  }));
};

ColorField.propTypes = (0, _assign2.default)({
  /**
   * Element id used as selection and search for automation testing
   */
  automationName: _propTypes2.default.string
}, _cwUi.CwColorField.propTypes);

exports.default = (0, _reactIntl.injectIntl)(ColorField);


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/managewidgets/components/colorfield/ColorField.js
// module id = 769
// module chunks = 10